module.exports = "<mat-progress-bar class=\"http-indicator\" [hidden]=\"notificationsService.numRequests < 1\" mode=\"indeterminate\"></mat-progress-bar>"